import { db, firebase } from '../../../../config/firebase_config'
import { cookies } from '@/utils/cookies'

class BehaviorRecorder {
  /* constructor() { }, */
  record(event, type, note) {
    db.collection('behaviors').add({
      name: cookies.get('GladName'),
      teamCode: String(cookies.get('GladTeamCode')),
      event,
      type,
      note,
      created: firebase.firestore.FieldValue.serverTimestamp(),
    })
  }

  /**
   * 比對 oldData/newData，產生異動記錄並自動呼叫 record
   * @param {Object} oldData 舊資料
   * @param {Object} newData 新資料
   * @param {Object} options { fieldMap, extraMap, title, type, event }
   * @param {Object} options.fieldMap 欄位對應表 需要比對異動的資料
   * @param {Object} options.extraMap 額外對應表 需要轉換的資料要放在這裡
   * @param {String} options.title 標題
   * @param {String} options.type 類型
   * @param {String} options.event 事件
   */
  recordDiffData(oldData, newData, options) {
    var fieldMap = options.fieldMap || {}
    var extraMap = options.extraMap || {}
    var title = options.title || ''
    var event = options.event || '點擊'
    var type = options.type || '司機資料'
    var call_number = newData.call_number || oldData.call_number || ''
    var diffList = []
    for (var key in fieldMap) {
      if (
        typeof oldData[key] === 'undefined' &&
        typeof newData[key] === 'undefined'
      )
        continue
      var oldVal = oldData[key]
      var newVal = newData[key]
      // 統一轉換邏輯：若extraMap有對應key則用extraMap[key][String(val)]做轉換
      if (extraMap[key]) {
        oldVal = extraMap[key][String(oldVal)]
        newVal = extraMap[key][String(newVal)]
      }
      if (String(oldVal) !== String(newVal)) {
        diffList.push(
          fieldMap[key] +
            ':&&(原) ' +
            (oldVal || '無') +
            '&&(新) ' +
            (newVal || '無'),
        )
      }
    }
    var note = title + '<' + call_number + '>'
    if (diffList.length > 0) {
      note += '&&' + diffList.join('&&')
      this.record(event, type, note)
    }
  }

  /**
   * 比對 oldData/newData 的服務陣列，產生異動記錄，格式如下：
   * (原) 服務A,服務B,服務C
   * (新增) 服務D,服務E
   * (刪除) 服務A,服務B
   * @param {Array} oldArr 舊服務陣列
   * @param {Array} newArr 新服務陣列
   * @param {Object} options { title, type, event, call_number }
   */
  recordDiffService(oldArr, newArr, options) {
    var title = options.title || ''
    var event = options.event || '點擊'
    var type = options.type || '司機資料'
    var call_number = options.call_number || ''
    // 轉字串陣列
    var oldSet = (oldArr || []).map(function (x) {
      return String(x)
    })
    var newSet = (newArr || []).map(function (x) {
      return String(x)
    })

    // 找出刪除與新增
    var deleted = oldSet.filter(function (x) {
      return newSet.indexOf(x) === -1
    })
    var added = newSet.filter(function (x) {
      return oldSet.indexOf(x) === -1
    })

    // 沒有異動就不記錄
    if (added.length === 0 && deleted.length === 0) return
    var note = title + '<' + call_number + '>' + '&&服務項目:'
    note += '&&(原) ' + oldSet.join(',')
    if (added.length > 0) {
      note += '&&(新增) ' + added.join(',')
    }
    if (deleted.length > 0) {
      note += '&&(刪除) ' + deleted.join(',')
    }
    this.record(event, type, note)
  }
}

export default new BehaviorRecorder()



// WEBPACK FOOTER //
// ./src/assets/js/libs/BehaviorRecorder.js